// Sayısal format yardımcıları — binlik virgül, ondalık nokta (1,234.56)

const sayiFormatlayici = (decimals) => new Intl.NumberFormat('en-US', {
  minimumFractionDigits: decimals,
  maximumFractionDigits: decimals,
});

export const formatSayi = (val, decimals = 2) => {
  if (val === null || val === undefined || val === '') return '';
  const n = Number(val);
  if (!Number.isFinite(n)) return '';
  return sayiFormatlayici(decimals).format(n);
};

export const formatPara = (val) => {
  const s = formatSayi(val, 2);
  return s === '' ? '' : `${s} ₺`;
};

// Antd InputNumber için: kullanıcı yazarken olduğu gibi göster, blur'da 2 hane padle.
// decimals = 0 ise hiç ondalık göstermez (tam sayı alanları).
const makeFormatter = (decimals) => (v, info) => {
  if (v === '' || v === null || v === undefined) return '';
  // Kullanıcı yazarken "10." ya da "10.5" girişini bozmamak için padleme.
  if (info && info.userTyping) {
    const [whole, dec] = String(v).split('.');
    const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return dec !== undefined ? `${grouped}.${dec}` : grouped;
  }
  return formatSayi(v, decimals);
};

const paraParser = (v) => {
  if (!v) return '';
  // Virgülleri sök, başındaki/sondaki boşlukları temizle
  return String(v).replace(/,/g, '').trim();
};

export const paraInputProps = {
  formatter: makeFormatter(2),
  parser: paraParser,
  step: 0.01,
  precision: 2,
};

// Ondalıklı sayı (miktar, stok, çarpan vb.) — görüntüde 2 hane.
export const sayiInputProps = {
  formatter: makeFormatter(2),
  parser: paraParser,
  step: 0.01,
  precision: 2,
};

// Tam sayı (adet, kişi vb.)
export const tamsayiInputProps = {
  formatter: makeFormatter(0),
  parser: paraParser,
  step: 1,
  precision: 0,
};
